import store from 'src/js/store';
import selectors from '../selectors';

const getEnableCopyPasteInstructionUrl = () => {
  const state = store.getState();

  return selectors.getEnableCopyPasteInstructionUrl(state);
};

export default getEnableCopyPasteInstructionUrl;
